<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_1123_50009)">
      <path d="M9.52358 0.952148H0.952148V9.52358H9.52358V0.952148Z" fill="#F25022" />
      <path d="M9.52358 10.4761H0.952148V19.0475H9.52358V10.4761Z" fill="#00A4EF" />
      <path d="M19.048 0.952148H10.4766V9.52358H19.048V0.952148Z" fill="#7FBA00" />
      <path d="M19.048 10.4761H10.4766V19.0475H19.048V10.4761Z" fill="#FFB900" />
    </g>
    <defs>
      <clipPath id="clip0_1123_50009">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
